module.exports = __webpack_public_path__ + "static/market-research-reports-c579e720d0ffa96e40e997c0878eb621.jpg";